import React, { useEffect, useState } from 'react';
import { ToastContainer } from 'react-toastify';
import { AppContextType } from '../../../../context/AppContext';
import useAppContext from '../../../../hooks/useAppContext';
import CompanyName from '../../../commonComponents/CompanyName';
import { CompanyNameType } from '../../../../static/types/commonTypes/companyNameType';
import StatusSignature from '../../../commonComponents/StatusSignature';
import { StatusSignatureType } from '../../../../static/types/commonTypes/statusSignatureType';
import TheSociety from '../../../commonComponents/TheSociety';
import HeadOfficeAddress from '../../../commonComponents/HeadOfficeAddress';
import { HeadOfficeAddressType } from '../../../../static/types/commonTypes/headOfficeAddressType';
import ManagerListWithRepresentative from './ManagerListWithRepresentative';
import ManagerWithRepresentative from './ManagerWithRepresentative';
import AdmissionToMeeting from '../creationSAS/AdmissionToMeeting';
import { admissionToMeetingType } from '../../../../static/types/commonTypes/admissionToMeetingType';
import ComponentsClause from '../crearionSASU/componentsClause';
import { Clause } from '../../../../static/types/clauseTypes/clauseType';
import CouncilMeeting from './CouncilMeeting';
import { CouncilMeetingType } from '../../../../static/types/limited-company-creation/councilMeetingType';
import Identity from './Identity';
import { IdentityType } from '../../../../static/types/limited-company-creation/identityType';
import IndividualPerson from '../../../commonComponents/IndividualPerson';
import { IndividualPersonType } from '../../../../static/types/commonTypes/individualType';
import { getCityWithPreposition } from '../../../../utils/functions/getCityWithPreposition';
import { ManagerWithRepresentativeType } from '../../../../static/types/limited-company-creation/managerWithRepresentativeType';
import { initialIndividualState } from '../../../../static/initialState/commonInitialState/individualInitialState';
import { SlArrowLeft, SlArrowRight } from "react-icons/sl";
import { FaUpload } from 'react-icons/fa';
import { GoArrowRight } from 'react-icons/go';
import { formatObjectText } from '../../../../utils/functions/formatObjectText';

interface AnnonceProps {
    txtAnnonce: string;
    updateActiveIndex: (index: number) => void;
    updateTxtAnnonce: (newTxt: string) => void;
    updateDenomination: (newTxt: string) => void;
    societyType: string | string[];
    societeSelected: string;
    updatesocieteSelected: (newTxt: string) => void;

}

const LimitedCompanyCreation: React.FC<AnnonceProps> = ({
    txtAnnonce,
    updateTxtAnnonce,
    updateActiveIndex,
    updateDenomination,
    societyType,
    updatesocieteSelected
}) => {

    const {

        individual, setIndividual,
        individualValidity, setIndividualValidity,
        individualChecked, setIndividualChecked,

        companyName, setCompanyName,
        companyNameValidity, setCompanyNameValidity,
        companyNameChecked, setCompanyNameChecked,

        statusSignature, setStatusSignature,
        statusSignatureValidity, setStatusSignatureValidity,
        statusSignatureChecked, setStatusSignatureChecked,

        theSociety, setTheSociety,
        theSocietyValidity, setTheSocietyValidity,
        theSocietyChecked, setTheSocietyChecked,

        headOfficeAddress, setHeadOfficeAddress,
        headOfficeAddressValidity, setHeadOfficeAddressValidity,
        headOfficeAddressChecked, setHeadOfficeAddressChecked,

        managersWithRepresentative, setManagersWithRepresentative,
        managersWithRepresentativeValidity, setManagersWithRepresentativeValidity,
        managersWithRepresentativeChecked, setManagersWithRepresentativeChecked,

        statutoryAuditorWithRepresentative, setStatutoryAuditorWithRepresentative,
        statutoryAuditorWithRepresentativeValidity, setStatutoryAuditorWithRepresentativeValidity,
        statutoryAuditorWithRepresentativeChecked, setStatutoryAuditorWithRepresentativeChecked,

        deputyAuditorWithRepresentative, setDeputyAuditorWithRepresentative,
        deputyAuditorWithRepresentativeValidity, setDeputyAuditorWithRepresentativeValidity,
        deputyAuditorWithRepresentativeChecked, setDeputyAuditorWithRepresentativeChecked,

        councilMeeting, setCouncilMeeting,
        councilMeetingValidity, setCouncilMeetingValidity,
        councilMeetingChecked, setCouncilMeetingChecked,

        identity, setIdentity,
        identityValidity, setIdentityValidity,
        identityChecked, setIdentityChecked,
        typeGeneralManagerData, setTypeGeneralManagerData,

        admission, setAdmission,
        clause, setClause,
        
        lastTab, setLastTab,
        draftFormData, setDraftFormData

    } = useAppContext() as AppContextType

    const [activeTab, setActiveTab] = useState<string>('companyName');
    const [visitedTabs, setVisitedTabs] = useState(['companyName']);
    const [submissive, setSubmissive] = useState<boolean>(false)

    const societyTypeOptions = Array.isArray(societyType) ? societyType : [societyType];

    useEffect(() => {
        // Si on vient d'un brouillon, restaurer l'onglet actif
        if ( lastTab ) {
            setActiveTab(lastTab);
            // Ajouter tous les onglets précédents comme visités
            const tabOrder = ['companyName', 'statusSignature', 'theCompany', 'headOfficeAddress', 'administrators', 'statutoryAuditor', 'deputyAuditor', 'admission', 'clause', 'councilMeeting', 'president'];
            const currentTabIndex = tabOrder.indexOf(lastTab);
            const visitedTabsArray = tabOrder.slice(0, currentTabIndex + 1);
            setVisitedTabs(visitedTabsArray);
        }
    }, []);

    const goToSupportPresse = () => {
        updateActiveIndex(2);
    }

    const switchTab = (tab: string) => {
        setActiveTab(tab);
    };

    // Soumettre le formulaire
    const validate = () => {
        if (!companyNameValidity) {
            setActiveTab('companyName')
        }
        else if (!statusSignatureValidity) {
            setActiveTab('statusSignature')
        }
        else if (!theSociety) {
            setActiveTab('theCompany')
        }
        else if (!headOfficeAddressValidity) {
            setActiveTab('headOfficeAddress')
        }
        else if (!managersWithRepresentativeValidity) {
            setActiveTab('administrators')
        }
        else if (!statutoryAuditorWithRepresentativeValidity) {
            setActiveTab('statutoryAuditor')
        }
        else if (!deputyAuditorWithRepresentativeValidity) {
            setActiveTab('deputyAuditor')
        }
        else if (!identityValidity || (typeGeneralManagerData === 1 && !individualValidity)) {
            setActiveTab('president')
        }

        let lastStepValidity = typeGeneralManagerData === 1 ? (identityValidity && individualValidity) : identityValidity

        return companyNameValidity && statusSignatureValidity && theSocietyValidity && headOfficeAddressValidity && managersWithRepresentativeValidity && statutoryAuditorWithRepresentativeValidity && deputyAuditorWithRepresentativeValidity && lastStepValidity
    };

    const handleSubmit = (e: React.FormEvent) => {

        e.preventDefault();

        const valid = validate()

        if (valid) {

            const managerWithRepresentativeText = (manager: ManagerWithRepresentativeType) => {
                if (manager.person === "Personne physique") {
                    return ` ${manager.personDetails.civility === 'Monsieur' ? 'M.' : 'Mme'} ${manager.personDetails.lastName} ${manager.personDetails.firstName}, demeurant ${manager.personDetails.address} ${manager.personDetails.additionalAddress ?? ""} ${manager.personDetails.postalCode} ${manager.personDetails.city}`
                }
                else if (manager.person === "Personne morale") {
                    return `${manager.entityDetails.companyName}, ${manager.entityDetails.legalForm} au capital de ${manager.entityDetails.capital} €, ayant son siège social ${manager.entityDetails.address} ${manager.entityDetails.additionalAddress ?? ""} ${manager.entityDetails.postalCode} ${manager.entityDetails.city}, ${manager.entityDetails.rcs} RCS ${getCityWithPreposition(manager.entityDetails.registrationOffice)} représentée par ${manager.entityDetails.civility === "Monsieur" ? "M. " : "Mme "} ${manager.entityDetails.lastName} ${manager.entityDetails.firstName}`
                }
            }

            const natureActText = statusSignature.actNature === "acte sous seing privé" ? 'acte SSP' : 'acte authentique'

            const tempText = `Par ${natureActText} du ${statusSignature.actDate},  il a été constitué une SA ayant les caractéristiques suivantes :
Dénomination : ${companyName.companyName}, ${theSociety.acronym ? `
Sigle: ${theSociety.acronym}` : ""},
Objet social : ${theSociety.object},
Siège social : ${headOfficeAddress.address} ${headOfficeAddress.additionalAddress ?? ""} ${headOfficeAddress.postalCode} ${headOfficeAddress.city}
Capital : ${theSociety.capital} €,
Durée : ${theSociety.duration > 1 ? `${theSociety.duration} ans` : `${theSociety.duration} an`},
Administrateurs :
-${managersWithRepresentative.map((manager: ManagerWithRepresentativeType, index: number) => managerWithRepresentativeText(manager)).join(",")}
Commissaires aux comptes :
- Titulaire : ${managerWithRepresentativeText(statutoryAuditorWithRepresentative)},
- Suppléant : ${managerWithRepresentativeText(deputyAuditorWithRepresentative)}, ${clause.clause ? `
Le Conseil d'administration du ${councilMeeting.meetingDate} a nommé Président du Conseil d'administration ${identity.civility === 'Monsieur' ? 'M.' : 'Mme'} ${identity.lastName} ${identity.firstName} ${typeGeneralManagerData === 1 ? `et nommé Directeur Général ${individual.civility === 'Monsieur' ? 'M.' : 'Mme'} ${individual.lastName} ${individual.firstName}, demeurant ${individual.address} ${individual.additionalAddress ?? ""} ${individual.postalCode} ${individual.city}` : ``}. ${admission.admissionText ? `Admission aux assemblées et droits de vote : ${admission.admissionText}` : ``}
Clause d'agrément : ${clause.clause}` : ''},
Immatriculation au RCS ${getCityWithPreposition(headOfficeAddress.registrationOffice)}.`;

            const formattedText = formatObjectText(tempText);
            updateTxtAnnonce(formattedText);
            updateDenomination(companyName.companyName);
        }

        else setSubmissive(false)
    };

    const handleNext = () => {

        // Formatage de theSociety (Objet Social)
        const formattedSociety = {
            ...theSociety,
            object: formatObjectText(theSociety.object)
        };

        // Utilisez formattedSociety pour mettre à jour les données
        setTheSociety(formattedSociety);

        if (activeTab === 'companyName') {
            setCompanyNameChecked(true)
            if (companyNameValidity) {
                switchTab(getNextTab('companyName'))
            }
        } else if (activeTab === 'statusSignature') {
            setStatusSignatureChecked(true)
            if (statusSignatureValidity) {
                switchTab(getNextTab('statusSignature'))
            }
        } else if (activeTab === 'theCompany') {
            setTheSocietyChecked(true)
            if (theSocietyValidity) {
                switchTab(getNextTab('theCompany'))
            }
        } else if (activeTab === 'headOfficeAddress') {
            setHeadOfficeAddressChecked(true)
            if (headOfficeAddressValidity) {
                switchTab(getNextTab('headOfficeAddress'))
            }
        } else if (activeTab === 'administrators') {
            setManagersWithRepresentativeChecked(true)
            if (managersWithRepresentativeValidity) {
                switchTab(getNextTab('administrators'))
            }
        } else if (activeTab === 'statutoryAuditor') {
            setStatutoryAuditorWithRepresentativeChecked(true)
            if (statutoryAuditorWithRepresentativeValidity) {
                switchTab(getNextTab('statutoryAuditor'))
            }
        } else if (activeTab === 'deputyAuditor') {
            setDeputyAuditorWithRepresentativeChecked(true)
            if (deputyAuditorWithRepresentativeValidity) {
                switchTab(getNextTab('deputyAuditor'))
            }
        } else if (activeTab === 'admission') {
            switchTab(getNextTab('admission'))
        } else if (activeTab === 'clause') {
            switchTab(getNextTab('clause'))
        } else if (activeTab === 'councilMeeting') {
            setCouncilMeetingChecked(true)
            if (councilMeetingValidity) {
                switchTab(getNextTab('councilMeeting'))
            }
        } else if (activeTab === 'president') {
            setIdentityChecked(true)
            if (typeGeneralManagerData === 0) {
                if (identityValidity) {
                    setSubmissive(true)
                }
            }
            else if (typeGeneralManagerData === 1) {
                setIndividualChecked(true)
                if (identityValidity && individualValidity) {
                    setSubmissive(true)
                }
            }
        }
    };
    
    useEffect(() => {
        setLastTab(activeTab);
    }, [activeTab]);

    const handlePrevious = () => {
        switchTab(getPreviousTab(activeTab));
        setSubmissive(false);
    };

    const getNextTab = (currentTab: string) => {
        switch (currentTab) {
            case 'companyName':
                return 'statusSignature';
            case 'statusSignature':
                return 'theCompany';
            case 'theCompany':
                return 'headOfficeAddress';
            case 'headOfficeAddress':
                return 'administrators';
            case 'administrators':
                return 'statutoryAuditor';
            case 'statutoryAuditor':
                return 'deputyAuditor';
            case 'deputyAuditor':
                return 'admission';
            case 'admission':
                return 'clause';
            case 'clause':
                return 'councilMeeting';
            case 'councilMeeting':
                return 'president';
            default:
                return currentTab;
        }
    };

    const getPreviousTab = (currentTab: string) => {
        switch (currentTab) {
            case 'statusSignature':
                return 'companyName';
            case 'theCompany':
                return 'statusSignature';
            case 'headOfficeAddress':
                return 'theCompany';
            case 'statutoryAuditor':
                return 'administrators';
            case 'administrators':
                return 'headOfficeAddress';
            case 'deputyAuditor':
                return 'statutoryAuditor';
            case 'admission':
                return 'deputyAuditor';
            case 'clause':
                return 'admission';
            case 'councilMeeting':
                return 'clause';
            case 'president':
                return 'councilMeeting';
            default:
                return currentTab;
        }
    };

    const tabs = [
  { key: "companyName", label: "Raison Sociale" },
  { key: "statusSignature", label: "Signature des Status" },
  { key: "theCompany", label: "La Société" },
  { key: "headOfficeAddress", label: "Adresse du Siège Social" },
  { key: "administrators", label: "Les administrateurs" },
  { key: "statutoryAuditor", label: "Commissaire aux comptes titulaire" },
  { key: "deputyAuditor", label: "Commissaire aux comptes suppléant" },
  { key: "admission", label: "Admission aux assemblées et droits de vote" },
  { key: "clause", label: "Clause d'agrément" },
  { key: "councilMeeting", label: "Première réunion du conseil d'administration" },
  { key: "president", label: "Président du conseil d'administration" },
];

    return (
        <>
                <div className="container my-3">
                <ul className="nav nav-underline">
                    {tabs
                    .filter((t) => t.key === activeTab) 
                    .map((t) => (
                        <li className="nav-item" key={t.key}>
                        <a
                            href={`#${t.key}`}
                            className={`nav-link active`} 
                        >
                            {t.label}
                        </a>
                        </li>
                    ))}
                </ul>
                </div>
            <ToastContainer />
            <form onSubmit={handleSubmit}>

                {
                    activeTab === 'companyName' &&
                    <CompanyName
                        changeCompanyName={(updatedData: Partial<CompanyNameType>) => setCompanyName({ ...companyName, ...updatedData })}
                        checked={companyNameChecked}
                        companyName={companyName}
                        onValidationChange={(isValid: boolean) => setCompanyNameValidity(isValid)}
                    />
                }

                {
                    activeTab === 'statusSignature' &&
                    <StatusSignature
                        changeStatusSignature={(updatedData: Partial<StatusSignatureType>) => setStatusSignature({ ...statusSignature, ...updatedData })}
                        checked={statusSignatureChecked}
                        onValidationChange={(isValid: boolean) => setStatusSignatureValidity(isValid)}
                        statusSignature={statusSignature}
                    />
                }

                {
                    activeTab === 'theCompany' &&
                    <TheSociety
                        checked={theSocietyChecked}
                        companyName={companyName}
                        setTheSociety={setTheSociety}
                        societyType={["Société anonyme"]}
                        theSociety={theSociety}
                        updateCompanyName={(updatedData: Partial<CompanyNameType>) => setCompanyName({ ...companyName, ...updatedData })}
                        updateCompanyNameValidity={(isValid: boolean) => setCompanyNameValidity(isValid)}
                        updateTheSocietyValidity={(isValid: boolean) => setTheSocietyValidity(isValid)}
                    />
                }

                {
                    activeTab === 'headOfficeAddress' &&
                    <HeadOfficeAddress
                        changeHeadOfficeAddress={(updatedData: Partial<HeadOfficeAddressType>) => setHeadOfficeAddress({ ...headOfficeAddress, ...updatedData })}
                        checked={headOfficeAddressChecked}
                        headOfficeAddress={headOfficeAddress}
                        onValidationChange={(isValid: boolean) => setHeadOfficeAddressValidity(isValid)}
                    />
                }

                {
                    activeTab === 'administrators' &&
                    <ManagerListWithRepresentative
                        addButtonText="Ajouter un Administrateur"
                        removeButtonText="Supprimer le dernier Administrateur"
                        checked={managersWithRepresentativeChecked}
                        managers={managersWithRepresentative}
                        representativeLabel='Représentée par :'
                        setManagers={setManagersWithRepresentative}
                        setManagersValidity={setManagersWithRepresentativeValidity}
                        societyTypeOptions={societyTypeOptions}
                        labelItem='Administrateur'
                        min={3}
                        draftFieldName = 'managersWithRepresentative'
                    />
                }

                {
                    activeTab === 'statutoryAuditor' &&
                    <ManagerWithRepresentative
                        checked={statutoryAuditorWithRepresentativeChecked}
                        manager={statutoryAuditorWithRepresentative}
                        setChecked={setStatutoryAuditorWithRepresentativeChecked}
                        updateManagerValidity={(isValid: boolean) => setStatutoryAuditorWithRepresentativeValidity(isValid)}
                        setManager={setStatutoryAuditorWithRepresentative}
                        societyType={societyTypeOptions}
                        draftFieldName = 'statutoryAuditorWithRepresentative'
                    />
                }

                {
                    activeTab === 'deputyAuditor' &&
                    <ManagerWithRepresentative
                        checked={deputyAuditorWithRepresentativeChecked}
                        manager={deputyAuditorWithRepresentative}
                        setChecked={setDeputyAuditorWithRepresentativeChecked}
                        updateManagerValidity={(isValid: boolean) => setDeputyAuditorWithRepresentativeValidity(isValid)}
                        setManager={setDeputyAuditorWithRepresentative}
                        societyType={societyTypeOptions}
                        draftFieldName = 'deputyAuditorWithRepresentative'
                    />
                }

                {
                    activeTab === 'admission' &&
                    <AdmissionToMeeting
                        admission={admission}
                        onChange={(updatedData: Partial<admissionToMeetingType>) => setAdmission({ ...admission, ...updatedData })}
                    />
                }

                {
                    activeTab === 'clause' &&
                    <ComponentsClause
                        changeClause={(updatedData: Partial<Clause>) => setClause({ ...clause, ...updatedData })}
                        clause={clause}
                    />
                }

                {
                    activeTab === 'councilMeeting' &&
                    <CouncilMeeting
                        changeCouncilMeeting={(updatedData: Partial<CouncilMeetingType>) => setCouncilMeeting({ ...councilMeeting, ...updatedData })}
                        checked={councilMeetingChecked}
                        councilMeeting={councilMeeting}
                        onValidationChange={(isValid: boolean) => setCouncilMeetingValidity(isValid)}
                    />
                }

                {
                    activeTab === 'president' &&
                    <>
                        <Identity
                            identity={identity}
                            changeIdentity={(updatedData: Partial<IdentityType>) => setIdentity({ ...identity, ...updatedData })}
                            checked={identityChecked}
                            onValidationChange={(isValid: boolean) => setIdentityValidity(isValid)}
                        />

                        <p>
                            Si la Direction Générale de la société est confiée à une autre personne que le Président du Conseil d'administration, indiquez son nom :
                        </p>

                        <div className="mb-3 row">

                            <label htmlFor="civilite" className="col-sm-2 col-form-label"> Saisir données </label>

                            <div className="col-sm-10">

                                <select
                                    className='form-select'
                                    name="civilite"
                                    id="civility"
                                    value={typeGeneralManagerData}
                                    onChange={event => {
                                        setSubmissive(false)
                                        setTypeGeneralManagerData(Number(event.target.value))
                                        setIndividual(initialIndividualState)
                                    }}
                                >
                                    <option value={1} > Oui </option>
                                    <option value={0} > Non </option>
                                </select>

                            </div>

                        </div>

                        {
                            typeGeneralManagerData === 1 &&
                            <IndividualPerson
                                changeIndividual={(updatedData: Partial<IndividualPersonType>) => setIndividual({ ...individual, ...updatedData })}
                                checked={individualChecked}
                                individual={individual}
                                onValidationChange={(isValid: boolean) => setIndividualValidity(isValid)}
                                draftFieldName = 'IndividualPerson'
                            />
                        }

                    </>
                }

                {
                    activeTab === 'president' &&
                    submissive &&
                    <div className="mt-4">
                        <h4>Texte de l'annonce:</h4>
                        <textarea
                            className="form-control"
                            rows={5}
                            value={txtAnnonce}
                            disabled
                        />
                    </div>
                }

                <div className='button-container'>
                    <div className="d-flex gap-2">
                        {
                            activeTab !== 'companyName' &&
                            <button color="#F4A261"
                                className="btn-add"
                                type="button"
                                onClick={handlePrevious} >
                                <SlArrowLeft className="icon" style={{ marginRight: '10px', fontSize: '20px' }} />
                                Modifier mon annonce
                            </button>
                        }

                        {
                            activeTab === 'president' &&
                            <button type="submit" onClick={handleNext}>Mettre à jour mon annonce
                                <FaUpload className="icon" style={{ marginLeft: '15px', fontSize: '20px' }} />
                            </button>
                        }

                        {
                            activeTab !== 'president' &&
                            <button color="#F4A261"
                                className="btn-add"
                                type="button"
                                onClick={handleNext} >
                                Suivant
                                <SlArrowRight className="icon" style={{ marginLeft: '10px', fontSize: '20px' }} />
                            </button>
                        }

                        {
                            submissive && activeTab === 'president' &&
                            <button color="#F4A261"
                                className="btn-add"
                                type="button"
                                onClick={goToSupportPresse} >
                                Sélection du support
                                <GoArrowRight className="icon" style={{ marginLeft: '10px', fontSize: '20px' }} />
                            </button>

                        }

                    </div>
                </div>


            </form>
        </>
    );
};

export default LimitedCompanyCreation;